import type { Component } from 'vue';
import CarIcon from '@/graphics/icons/CarIcon.vue';
import PetsIcon from '@/graphics/icons/PetsIcon.vue';
import SpecialNeedsIcon from '@/graphics/icons/SpecialNeedsIcon.vue';
import TwinsIcon from '@/graphics/icons/TwinsIcon.vue';
import { Requirements } from '@/store/modules/job/types';

export interface RequirementOption {
  value: Requirements;
  textLabel: string;
  icon: Component;
  fillsCircle?: boolean;
}

export const requirementOptions: RequirementOption[] = [
  {
    value: Requirements.HAS_A_CAR,
    icon: CarIcon,
    textLabel: 'Sitter has own car',
  },
  {
    value: Requirements.COMFORTABLE_WITH_PETS,
    icon: PetsIcon,
    textLabel: 'Comfortable with pets',
  },
  {
    value: Requirements.SPECIAL_NEEDS_EXPERIENCE,
    icon: SpecialNeedsIcon,
    textLabel: 'Special needs experience',
  },
  {
    value: Requirements.MULTIPLES_EXPERIENCE,
    icon: TwinsIcon,
    textLabel: 'Multiples experience',
  },
];
